<template>
  <div class='position-fixed w_100' id='fixed-header' style="z-index: 20; top: 0px;">
    <KwHeaderMenu>
      <KwKiwitaxiLogoNew v-if="isNewDesignTheme" @click.native="goToMain" slot='logo'/>
      <KwSvgicon
        v-else
        @click.native="goToMain"
        slot='logo'
        name='logo-new'
      />
      <Language slot="menu" right/>
    </KwHeaderMenu>
  </div>
</template>

<script>
import KwHeaderMenu from '@kiwitaxi/vue-components/dist/KwHeaderMenu';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';
import KwKiwitaxiLogoNew from '@/components/UI/KwKiwitaxiLogoNew.vue';
import { locations, newDesignDetector } from '@/mixins';
import Language from './components/Language.vue';

export default {
  name: 'HeaderComponentUnsigned',
  mixins: [locations, newDesignDetector],
  components: {
    KwKiwitaxiLogoNew,
    KwHeaderMenu,
    KwSvgicon,
    Language,
  },
  methods: {
    goToMain() {
      this.locationReplace(window.location.origin);
    },
  },
};
</script>

<style lang='scss'>
.page-header {
  .page-header__logo--new {
    width: 45px;
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Unsigned.vue